export default __webpack_public_path__ + "static/media/Ameritas.6e280787.png";